module.exports = __webpack_public_path__ + "static/media/icon-arrow-opponent.7cdec548.svg";